import Api from '../../api/index'

import { Ability } from '@casl/ability'
export const ability = new Ability()

// export const ability = appAbility

export const User = {
  namespaced: true,
  // plugins: [
  //   abilityPlugin
  // ],
  state: {
    oneUser: null, //to store SHOW/LOGIN response
    allUsers: null, //to store SHOW/LOGIN response
    allRoles: null, //to store SHOW/LOGIN response
    rules: null,

    token_type: null,
    token_access_token: null,
    token_client: null,
    toekn_uid: null,
    toekn_expiry: null,

    // promises results
    createUserWasGood: null,
    createUserMessage: null,

    updateUserWasGood: null,
    updateUserMessage: null,

     // less used
    // indexUserWasGood: null,
    // indexUserMessage: null,

    // showUserWasGood: null,
    // showUserMessage: null,
  },
  getters: {
    getUser: state => {
      return state.oneUser;
    }
  },

  mutations: {
    setOneUser(state, User){
      state.oneUser = User
    },
    setProfile(state, User){
      state.oneUser = User
    },
    setAllUsers(state, Users){
      state.allUsers = Users
    },
    setAllRoles(state, roles){
      state.allRoles = roles
    },

    createResponse(state, {was_good, msg}){
      state.createUserWasGood = was_good
      state.createUserMessage = msg
      setTimeout(() => {
        state.createUserWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateUserWasGood = was_good
      state.updateUserMessage = msg
      setTimeout(() => {
        state.updateUserWasGood = null
      }, 100);
    },

    clearOneUser(state){
      state.oneUser = null
      state.profile = null
    },
    clearAllUsers(state){
      state.allUsers = null
    },
  },

  actions: {
    clearAllUsers({commit}){
      commit('clearAllUsers')
    },
    clearOneUser({commit}){
      commit('clearOneUser')
    },

    setUser(context, data){
      context.commit('setOneUser', data)
    },
    setProfile(context, data){
      context.commit('setProfile', data)
    },
    fetchProfile(context, data){
      Api.User.profile()
        .then(response => response.data)
        .then(user=>{
          context.commit('setProfile', user)
        }).catch(function(error) {
          console.log({error_in_profile: error});
        });

      // if (data) context.commit('setTokenData', localStorage.default_auth_token)
    },

    index(context, filter) {
      Api.User.index(filter)
        .then(response => response.data)
        .then(users => {
          context.commit('setAllUsers', users);
          // context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          // context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    indexRoles(context, filter) {
      Api.Role.index(filter)
        .then(response => response.data)
        .then(roles => {
          context.commit('setAllRoles', roles);
          // context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          // context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },

    create(context, new_user) {
      Api.User.create(new_user)
        .then(response => response.data)
        .then(User => {
          // context.commit('setOneUsers', User); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    update(context, user) {
      Api.User.update(user)
        .then(response => response.data)
        .then(user => {
          // context.commit('setOneuser', user); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    updateToDelete(context, user) {
      Api.User.updateToDelete(user)
        .then(response => response.data)
        .then(user => {
          // context.commit('setOneuser', user); // not often used
          context.commit('updateResponse', {msg: 'Apagado com sucesso', was_good: true});
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error, was_good: false});
          console.log(error);
        });
    },

  }

};

